import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  fr: {
    translation: {
      // Navigation
      "nav.home": "Accueil",
      "nav.looks": "Looks",
      "nav.quiz": "Quiz Style",
      "nav.cart": "Panier",
      "nav.account": "Mon Compte",
      "nav.admin": "Admin",
      
      // Home
      "home.hero.title": "Votre Style,",
      "home.hero.subtitle": "Notre Expertise",
      "home.hero.cta": "Découvrir les looks",
      "home.featured": "Looks Sélectionnés",
      "home.quiz.title": "Trouvez votre style",
      "home.quiz.description": "Répondez à quelques questions et découvrez les looks parfaits pour vous.",
      "home.quiz.cta": "Faire le quiz",
      "home.newsletter.title": "Restez inspiré",
      "home.newsletter.description": "Recevez nos dernières collections et offres exclusives.",
      "home.newsletter.placeholder": "Votre email",
      "home.newsletter.cta": "S'inscrire",
      
      // Looks
      "looks.title": "Nos Looks",
      "looks.filter.all": "Tous",
      "looks.filter.chic": "Chic",
      "looks.filter.casual": "Casual",
      "looks.filter.glamour": "Glamour",
      "looks.bundle.price": "Prix Bundle",
      "looks.bundle.savings": "Économisez",
      "looks.bundle.add": "Ajouter le look",
      "looks.items.included": "Articles inclus",
      
      // Cart
      "cart.title": "Votre Panier",
      "cart.empty": "Votre panier est vide",
      "cart.subtotal": "Sous-total",
      "cart.shipping": "Livraison",
      "cart.shipping.free": "Gratuite",
      "cart.discount": "Réduction",
      "cart.total": "Total",
      "cart.checkout": "Commander",
      "cart.continue": "Continuer vos achats",
      "cart.promo": "Code promo",
      "cart.promo.apply": "Appliquer",
      
      // Checkout
      "checkout.title": "Finaliser la commande",
      "checkout.shipping": "Adresse de livraison",
      "checkout.payment": "Paiement",
      "checkout.payment.viva": "Carte bancaire (Viva)",
      "checkout.payment.paypal": "PayPal",
      "checkout.order": "Passer la commande",
      "checkout.success": "Commande confirmée !",
      "checkout.success.message": "Merci pour votre commande. Vous recevrez un email de confirmation.",
      
      // Forms
      "form.firstName": "Prénom",
      "form.lastName": "Nom",
      "form.email": "Email",
      "form.phone": "Téléphone",
      "form.address": "Adresse",
      "form.city": "Ville",
      "form.postalCode": "Code postal",
      "form.country": "Pays",
      
      // Auth
      "auth.login": "Connexion",
      "auth.register": "Créer un compte",
      "auth.logout": "Déconnexion",
      "auth.password": "Mot de passe",
      "auth.forgotPassword": "Mot de passe oublié ?",
      
      // Quiz
      "quiz.title": "Quiz Style",
      "quiz.question1": "Quelle ambiance vous correspond le plus ?",
      "quiz.question2": "Pour quelle occasion cherchez-vous des looks ?",
      "quiz.question3": "Quel est votre budget moyen par look ?",
      "quiz.next": "Suivant",
      "quiz.prev": "Précédent",
      "quiz.finish": "Voir mes résultats",
      "quiz.results": "Vos looks personnalisés",
      
      // Common
      "common.loading": "Chargement...",
      "common.error": "Une erreur est survenue",
      "common.success": "Succès !",
      "common.save": "Enregistrer",
      "common.cancel": "Annuler",
      "common.delete": "Supprimer",
      "common.edit": "Modifier",
      "common.view": "Voir",
      "common.search": "Rechercher",
      "common.filter": "Filtrer",
      "common.sort": "Trier",
      "common.all": "Tout",
      
      // Footer
      "footer.about": "À propos",
      "footer.contact": "Contact",
      "footer.faq": "FAQ",
      "footer.shipping": "Livraison",
      "footer.returns": "Retours",
      "footer.legal": "Mentions légales",
      "footer.privacy": "Confidentialité",
      "footer.terms": "CGV"
    }
  },
  en: {
    translation: {
      // Navigation
      "nav.home": "Home",
      "nav.looks": "Looks",
      "nav.quiz": "Style Quiz",
      "nav.cart": "Cart",
      "nav.account": "My Account",
      "nav.admin": "Admin",
      
      // Home
      "home.hero.title": "Your Style,",
      "home.hero.subtitle": "Our Expertise",
      "home.hero.cta": "Discover looks",
      "home.featured": "Featured Looks",
      "home.quiz.title": "Find your style",
      "home.quiz.description": "Answer a few questions and discover the perfect looks for you.",
      "home.quiz.cta": "Take the quiz",
      "home.newsletter.title": "Stay inspired",
      "home.newsletter.description": "Receive our latest collections and exclusive offers.",
      "home.newsletter.placeholder": "Your email",
      "home.newsletter.cta": "Subscribe",
      
      // Looks
      "looks.title": "Our Looks",
      "looks.filter.all": "All",
      "looks.filter.chic": "Chic",
      "looks.filter.casual": "Casual",
      "looks.filter.glamour": "Glamour",
      "looks.bundle.price": "Bundle Price",
      "looks.bundle.savings": "Save",
      "looks.bundle.add": "Add look",
      "looks.items.included": "Included items",
      
      // Cart
      "cart.title": "Your Cart",
      "cart.empty": "Your cart is empty",
      "cart.subtotal": "Subtotal",
      "cart.shipping": "Shipping",
      "cart.shipping.free": "Free",
      "cart.discount": "Discount",
      "cart.total": "Total",
      "cart.checkout": "Checkout",
      "cart.continue": "Continue shopping",
      "cart.promo": "Promo code",
      "cart.promo.apply": "Apply",
      
      // Checkout
      "checkout.title": "Complete your order",
      "checkout.shipping": "Shipping address",
      "checkout.payment": "Payment",
      "checkout.payment.viva": "Credit card (Viva)",
      "checkout.payment.paypal": "PayPal",
      "checkout.order": "Place order",
      "checkout.success": "Order confirmed!",
      "checkout.success.message": "Thank you for your order. You will receive a confirmation email.",
      
      // Forms
      "form.firstName": "First name",
      "form.lastName": "Last name",
      "form.email": "Email",
      "form.phone": "Phone",
      "form.address": "Address",
      "form.city": "City",
      "form.postalCode": "Postal code",
      "form.country": "Country",
      
      // Auth
      "auth.login": "Login",
      "auth.register": "Create account",
      "auth.logout": "Logout",
      "auth.password": "Password",
      "auth.forgotPassword": "Forgot password?",
      
      // Quiz
      "quiz.title": "Style Quiz",
      "quiz.question1": "Which ambiance suits you best?",
      "quiz.question2": "What occasion are you looking for?",
      "quiz.question3": "What's your average budget per look?",
      "quiz.next": "Next",
      "quiz.prev": "Previous",
      "quiz.finish": "See my results",
      "quiz.results": "Your personalized looks",
      
      // Common
      "common.loading": "Loading...",
      "common.error": "An error occurred",
      "common.success": "Success!",
      "common.save": "Save",
      "common.cancel": "Cancel",
      "common.delete": "Delete",
      "common.edit": "Edit",
      "common.view": "View",
      "common.search": "Search",
      "common.filter": "Filter",
      "common.sort": "Sort",
      "common.all": "All",
      
      // Footer
      "footer.about": "About",
      "footer.contact": "Contact",
      "footer.faq": "FAQ",
      "footer.shipping": "Shipping",
      "footer.returns": "Returns",
      "footer.legal": "Legal",
      "footer.privacy": "Privacy",
      "footer.terms": "Terms"
    }
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'fr',
    fallbackLng: 'fr',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
